import type { FaireProductEntity } from "../../entity_types/product";

export const p_fystkhzdck: FaireProductEntity = {
  token: "p_fystkhzdck",
  type: "product",
  name: "Cabin Time Games: Tug of War (Wholesale Pack of 4)",
  brandToken: "b_qsh7rux99c",
  brandName: "Cabin Time Games",
  imageUrl: "https://cdn.faire.com/fastly/5727eb8728488aab550f0a5dc07a395215b8595ed7a3de5f58d3f49a372db590.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93996f675beb54ee1721b0fd2ebe241a5d451b85920bef72d87cf66549963470.jpeg",
    "https://cdn.faire.com/fastly/3a91c68f1765a36eb17ac43ff8a6f14e0d4a4715d82ae15f0268976d2aa29477.jpeg",
    "https://cdn.faire.com/fastly/08ef31bd5f305c93c8c48ec67d5a624a9355baa2a457ff072d8efa5d9b74468c.jpeg",
    "https://cdn.faire.com/fastly/3225382c1d4d63f997f515f8a14d279a462d2661d9f67d3e861361304b0a3ed4.jpeg",
    "https://cdn.faire.com/fastly/e5310761b30d4c2420c784d7c4a615a7682b841bd73df77dc131942d23fb3424.jpeg",
    "https://cdn.faire.com/fastly/35902c8363bed3b7efc854859a5d1f7bf3ba98f709968f275140642c014adc08.jpeg"
  ],
  priceDollars: 35.98,
  description: "Who will pull the marker across the line? In Cabin Time Games: Tug of War, two players reveal cards, move the marker toward their side, and use special cards to turn the game around. The lead can change in an instant, making everyone eager for a rematch.\n\nCreated by camp directors Allison Miller and Austin Nelson and tested with real campers, this card game brings a lively contest to family nights, vacations, and gatherings all year long. \n\nEach boxed game includes a collectible patch.\n\nThis wholesale case contains 4 copies of Cabin Time Games: Tug of War. Suggested retail price is $17.99 per game.\n",
  tags: [],
  msrpDollars: 71.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:37.931Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
